import { __rest } from "tslib";
import React from 'react';
import BlockHeader from '../../components/BlockHeader/BlockHeader';
import Link from '../../components/Link/Link';
import { Col, GridColumnSize, Row } from '../../grid';
import { block } from '../../utils';
import './LinkTable.css';
const b = block('LinkTable');
const LinkTable = ({ items, title, description, linkTheme = 'normal' }) => {
    return (React.createElement("div", { className: b() },
        React.createElement(BlockHeader, { title: title, description: description, className: b('block-title') }),
        React.createElement(Row, { className: b('links') }, items.map((column, index) => (React.createElement(Col, { key: (column.length && column[0].url) || index, sizes: {
                [GridColumnSize.Lg]: 4,
                [GridColumnSize.Md]: 6,
                [GridColumnSize.All]: 12,
            } }, column.map((_a) => {
            var { theme = linkTheme } = _a, link = __rest(_a, ["theme"]);
            return (React.createElement(Link, Object.assign({ key: link.url }, link, { theme: theme })));
        })))))));
};
export default LinkTable;
